import { NSARouterMakerResult } from "namirasoft-account-react";
import { CategoryInputRow, CategoryRow, CategoryScopeRow } from "namirasoft-field";
import { NamirasoftMap } from "namirasoft-site-map";
import { NSBox, NSBoxEntity, NSBoxString, NSBoxTextArea, NSColumn } from "namirasoft-site-react";
import { Component, createRef } from "react";
import { FieldEntities } from "../FieldEntities";
import { FieldLayout } from "../FieldLayout";
import { FieldProps } from "../FieldProps";

interface CategoryEditPageProps extends NSARouterMakerResult, FieldProps
{
    isEdit: boolean;
}

interface CategoryEditPageState { }

export default class CategoryEditPage extends Component<CategoryEditPageProps, CategoryEditPageState>
{
    NSBoxEntity_CategoryScope = createRef<NSBoxEntity<CategoryScopeRow>>();
    NSBoxString_Name = createRef<NSBoxString>();
    NSBoxTexArea_Description = createRef<NSBoxTextArea>();

    constructor(props: CategoryEditPageProps)
    {
        super(props);
        this.state = {};
    }

    override render()
    {
        let namirasoft = new NamirasoftMap(this.props.account.token_manager, console.error);
        return (
            <FieldLayout<CategoryRow, CategoryInputRow>
                {...this.props}
                action={{
                    description: this.props.isEdit ? "This section allows you to update the details of an existing category." : "This section allows you to add a new category by entering its details."
                }}
                pages={{
                    entity: FieldEntities.category(this.props),
                    edit: {
                        ...this.props,
                        ui: {
                            tab_page_edit: {
                                editor: {
                                    getInputRow: () =>
                                    {
                                        let category_scope_id = this.NSBoxEntity_CategoryScope.current?.getValueOne() ?? "";
                                        let name = this.NSBoxString_Name.current?.getValue() ?? "";
                                        let description = this.NSBoxTexArea_Description.current?.getValue() ?? "";

                                        return {
                                            workspace_id: "",
                                            category_scope_id,
                                            name,
                                            description,
                                            category_category: [],
                                            category_field: [],
                                            category_tag: [],
                                        };
                                    },
                                    setRow: (row) =>
                                    {
                                        this.NSBoxEntity_CategoryScope.current?.setValue(row.category_scope_id);
                                        this.NSBoxString_Name.current?.setValue(row.name);
                                        this.NSBoxTexArea_Description.current?.setValue(row.description ?? "");
                                    }
                                }
                            }
                        }
                    }
                }}
            >
                <NSColumn>
                    <NSBoxString
                        ref={this.NSBoxString_Name}
                        title="Name"
                        required
                        info={{ link: "https://namirasoft.com/field/console-guide/category/#field-name" }}
                        style={{ width: NSBox.width.double }}
                    />
                    <NSBoxEntity
                        ref={this.NSBoxEntity_CategoryScope}
                        title="Category Scope"
                        required
                        multiple={false}
                        table={namirasoft.field.tables.category_scope}
                        getValue={item => item.id}
                        getTitle={item => item.name}
                        getSort={() => null}
                        info={{ link: "https://namirasoft.com/field/console-guide/category/#field-category-scope" }}
                        style={{ width: NSBox.width.double }}
                    />
                    <NSBoxTextArea
                        ref={this.NSBoxTexArea_Description}
                        title="Description"
                        required={false}
                        style={{ width: NSBox.width.double }}
                        info={{ link: "https://namirasoft.com/field/console-guide/category/#field-description" }}
                    />
                </NSColumn>
            </FieldLayout>
        );
    }
}